import { Injectable } from '@angular/core';
import { ApiService } from '../../services/apiservice/apiservice.service';
import { Observable } from 'rxjs';
import { ConfigService } from '../../services/config/config.service';

@Injectable()
export class SettingsService {
  url = '';

  // items on hold variables
  filterBy = 'all';
  sortBy = 'title';

  //item from other libs variables
  sortByforLibs = 'title';

  constructor(
    private _apiService: ApiService,
    private _configService: ConfigService,
  ) {}

  // WEB LINKS
  getWebLinks(): Observable<any> {
    this.url = this._configService.agApi + '/account/GetFavoriteWebLinks';
    return this._apiService.get(this.url);
  }

  addFavWebLink(data): Observable<any> {
    this.url = this._configService.agApi + '/account/AddFavoriteWebLink';
    return this._apiService.post(this.url, data);
  }

  updateFavWebLink(data): Observable<any> {
    this.url = this._configService.agApi + '/account/UpdateFavoriteWebLink';
    return this._apiService.post(this.url, data);
  }

  deleteFavWebLink(data): Observable<any> {
    this.url = this._configService.agApi + '/account/DeleteFavoriteWebLink';
    return this._apiService.post(this.url, data);
  }

  // FAVORITE RESOURCES
  getFavResources(): Observable<any> {
    this.url = this._configService.agApi + '/account/GetFavoriteResources';
    return this._apiService.get(this.url);
  }
  setFavResources(data): Observable<any> {
    this.url = this._configService.agApi + '/account/SetFavoriteResources';
    return this._apiService.post(this.url, data);
  }
}
